<!-- <section class="g-bg-gray-light-v5 g-py-50" style="margin-top:50px">
  <div class="container">
    <div class="d-sm-flex text-center">
      <div class="align-self-center">
        <h2 class="h3 g-font-weight-300 w-100 g-mb-10 g-mb-0--md">
          <p>Awards </p>
        </h2>
      </div>


    </div>
  </div>
</section> -->
<section class="g-brd-bottom g-brd-gray-light-v4 g-py-30 breadcrumbs">
    <div class="container">
        <ul class="d-flex justify-content-between u-list-inline">
            <li class="list-inline-item g-mr-15">
                <a class="u-link-v5 g-color-text g-pr-10" routerLink="/">Home</a>
                <i class="g-color-gray-light-v2 g-ml-5 fa fa-angle-right"></i>
            </li>
            <li class="list-inline-item g-color-primary">
                <span>Mother's Day</span>
            </li>
        </ul>
    </div>
</section>

<div class="container g-pt-100 g-pb-70" style="margin-top: -50px">
    <div class="row">
        <div class="col-lg-9 g-mb-30">
            <article class="text-center">
                <header class="g-mb-30">
                    <h1 class="g-color-black g-font-weight-600 text-uppercase g-mb-15">Mother's Day 2025</h1>
                    <p class="g-color-gray-dark-v2 g-font-size-16 g-mb-30">
                        <i class="fa fa-calendar g-mr-5"></i> March 30, 2025
                    </p>
                </header>

                <figure class="g-mb-40">
                    <img
                        src="../../../assets/vendor/revolution-slider/revolution/assets/svg/av/Mother's Day CSR.jpeg"
                        alt="NSIA Insurance Mother's Day 2025"
                        class="img-fluid rounded mx-auto d-block"
                        style="max-width: 100%"
                    />
                </figure>

                <div class="g-mb-30 text-center">
                    <p class="lead g-mb-30" style="font-weight: 600">
                        For NSIA Insurance, Mother's Day 2025 wasn't just about acknowledging the essence of mothers; it
                        was about showing up and making a real impact. The company marked the occasion by visiting
                        Ayinke House, the maternity ward at Lagos State University Teaching Hospital (LASUTH), where
                        essential mother-and-baby care items were donated to new and expectant mothers.
                    </p>
                </div>

                <div class="article-content g-line-height-1_8 g-mb-30 text-center">
                    <p class="g-mb-30">
                        This gesture builds on last year's successful outreach at Lagos Island Maternity Hospital, with
                        NSIA Insurance taking a step further this time, providing even more care packages. These
                        thoughtful gifts, including baby clothes and toiletries, were meant to ease the challenges
                        mothers face during the early stages of motherhood and remind them they are supported.
                    </p>

                    <blockquote
                        class="g-brd-primary g-brd-left g-brd-3 g-pa-20 g-mb-30 text-center mx-auto"
                        style="max-width: 80%"
                    >
                        <p class="g-font-style-italic g-font-size-18">
                            "We're not just celebrating mothers this year, we're showing up for them in a way that
                            matters. Our goal is to offer practical support and let them know they are valued."
                        </p>
                        <footer class="g-color-primary">Moruf Apampa, MD/CEO of NSIA Insurance</footer>
                    </blockquote>

                    <p class="g-mb-0">
                        This initiative is part of NSIA Insurance's broader commitment to social responsibility, going
                        beyond insurance services to create meaningful change in the community. By supporting mothers in
                        their journey, NSIA Insurance is making a tangible difference in their lives, proving that even
                        small acts of kindness can have a lasting impact.
                    </p>
                </div>

                <!-- Social Sharing (optional) -->
                <!-- <div class="text-center g-mt-50">
            <h5 class="g-color-gray-dark-v3 g-mb-20">Share This Story</h5>
            <ul class="list-inline mb-0">
              <li class="list-inline-item g-mx-2">
                <a class="u-icon-v1 u-icon-size--sm g-color-primary g-bg-white g-color-white--hover g-bg-primary--hover rounded-circle" href="#">
                  <i class="fa fa-facebook"></i>
                </a>
              </li>
              <li class="list-inline-item g-mx-2">
                <a class="u-icon-v1 u-icon-size--sm g-color-primary g-bg-white g-color-white--hover g-bg-primary--hover rounded-circle" href="#">
                  <i class="fa fa-twitter"></i>
                </a>
              </li>
              <li class="list-inline-item g-mx-2">
                <a class="u-icon-v1 u-icon-size--sm g-color-primary g-bg-white g-color-white--hover g-bg-primary--hover rounded-circle" href="#">
                  <i class="fa fa-linkedin"></i>
                </a>
              </li>
            </ul>
          </div> -->
            </article>
        </div>
        <div class="col-lg-3 g-mb-30">
            <!-- Links -->
            <app-sidebar></app-sidebar>
            <!-- End Fast Facts -->
        </div>
    </div>
</div>
